import { render } from "./DevicesView.vue?vue&type=template&id=72e3e366&scoped=true"
import script from "./DevicesView.vue?vue&type=script&lang=js"
export * from "./DevicesView.vue?vue&type=script&lang=js"

import "./DevicesView.vue?vue&type=style&index=0&id=72e3e366&scoped=true&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e3e366"]])

export default __exports__